import { Component, inject, input, OnInit, signal } from "@angular/core";

import { Passkey } from "../../../_models/passkey.interface";
import { PasskeyService } from "../../../_services/passkey.service";
import { httpErrorMessage } from "../../../_helpers/http-error-message";
import { PasskeyTableComponent } from "../../_shared/passkey-table/passkey-table.component";

// Admin-Ansicht: Passkeys eines Nutzers einsehen und löschen, z. B. bei
// verlorenem Gerät oder ausgeschiedenen Mitarbeitern. Registrieren für fremde
// Nutzer gibt es bewusst nicht (siehe bentomax/hawk#596).
@Component({
  selector: "hawk-user-passkeys",
  standalone: true,
  imports: [PasskeyTableComponent],
  template: `
    @if (error(); as text) {
      <div class="bm-alert bm-alert-error bm-alert-dash mb-2">{{ text }}</div>
    }
    @if (loading()) {
      <span class="bm-loading bm-loading-spinner bm-loading-md"></span>
    } @else {
      <hawk-passkey-table [passkeys]="passkeys()" (deleteConfirmed)="deletePasskey($event)" />
    }
  `,
})
export class UserPasskeysComponent implements OnInit {
  userId = input.required<number>();

  private passkeyService = inject(PasskeyService);

  protected passkeys = signal<Passkey[]>([]);
  protected loading = signal(true);
  protected error = signal("");

  public ngOnInit() {
    this.passkeyService.getUserPasskeys(this.userId()).subscribe({
      next: (passkeys) => {
        this.passkeys.set(passkeys);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set(httpErrorMessage(err, "Die Passkeys konnten nicht geladen werden."));
        this.loading.set(false);
      },
    });
  }

  protected deletePasskey(passkey: Passkey) {
    this.error.set("");
    this.passkeyService.deleteUserPasskey(this.userId(), passkey.id).subscribe({
      next: () => {
        this.passkeys.update((list) => list.filter((p) => p.id !== passkey.id));
      },
      error: (err) => {
        this.error.set(httpErrorMessage(err, "Der Passkey konnte nicht gelöscht werden."));
      },
    });
  }
}
